import React from 'react'

function NotFound() {
    return (
        <div>
            404 Error@
        </div>
    )
}

export default NotFound
